// import { format } from "date-fns";
import React from 'react';

import * as APPDATA from '@/constants/pcConstAppData';

export const COLUMNS = [
  {
    Header: APPDATA.DEVICE_DATE,
    // Footer: APPDATA.DEVICE_DATE,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.Time,
    // disableFilters: true,
    id: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.Date,
    sticky: 'left',
    Cell: ({value}) =>
      new Date(value).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }),
  },
  {
    Header: APPDATA.TIME,
    // Footer: APPDATA.TIME,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.Time,
    sticky: 'left',
    Cell: ({value}) => new Date(value).toLocaleTimeString('it-IT'),
  },
  {
    Header: APPDATA.CYCLE,
    // Footer: APPDATA.CYCLE,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.Cycle,
    sticky: 'left',
    width: 200,
  },
  {
    Header: APPDATA.STATE,
    // Footer: APPDATA.STATE,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.State,
    width: 200,
  },
  {
    Header: (
      <>
        {APPDATA.FIELD_NAME.SAMPLE_VOLUME}
        <br />
        {APPDATA.UNIT.ml}
      </>
    ),
    // Footer: APPDATA.FIELD_NAME.SAMPLE_VOLUME,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.SampleVolume,
    Cell: ({value}) =>
      value ? Number(Number(value).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)) : '0',
    width: 200,
  },
  {
    Header: (
      <>
        {APPDATA.FIELD_NAME.BUFFER_VOLUME}
        <br />
        {APPDATA.UNIT.ml}
      </>
    ),
    // Footer: APPDATA.FIELD_NAME.BUFFER_VOLUME,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.BufferVolume,
    Cell: ({value}) =>
      value ? Number(Number(value).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)) : '0',
    width: 200,
  },
  {
    Header: (
      <>
        {APPDATA.FIELD_NAME.CONCENTRATION}
        <br />
        {APPDATA.UNIT.mg_per_ml}
      </>
    ),
    // Footer: APPDATA.FIELD_NAME.CONCENTRATION,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.Concentration,
    Cell: ({value}) =>
      value ? Number(Number(value).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)) : '0',
    width: 200,
  },
  {
    Header: (
      <>
        {APPDATA.FIELD_NAME.VACUUM_PRESSURE}
        <br />
        {APPDATA.UNIT.psi}
      </>
    ),
    // Footer: APPDATA.FIELD_NAME.VACUUM_PRESSURE,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.VacuumPressure,
    Cell: ({value}) =>
      value ? Number(Number(value).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)) : '0',
    width: 220,
  },
  {
    Header: (
      <>
        {APPDATA.FIELD_NAME.SOURCE_PRESSURE}
        <br />
        {APPDATA.UNIT.psi}
      </>
    ),
    // Footer: APPDATA.FIELD_NAME.SOURCE_PRESSURE,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.ValvePressure,
    Cell: ({value}) =>
      value ? Number(Number(value).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)) : '0',
    width: 200,
  },
  {
    Header: (
      <>
        {APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE}
        <br />
        {APPDATA.UNIT.psi}
      </>
    ),
    // Footer: APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.DiaphragmPressure,
    Cell: ({value}) =>
      value ? Number(Number(value).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)) : '0',
    width: 250,
  },
  {
    Header: (
      <>
        {APPDATA.FIELD_NAME.BOTTLE_PRESSURE}
        <br />
        {APPDATA.UNIT.psi}
      </>
    ),
    // Footer: APPDATA.FIELD_NAME.BOTTLE_PRESSURE,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.ReturnValvePressure,
    Cell: ({value}) =>
      value ? Number(Number(value).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)) : '0',
    width: 270,
  },
  {
    Header: APPDATA.ELAPSED_TIME_IN_SECONDS,
    // Footer: APPDATA.ELAPSED_TIME,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.ElapsedTime,
    Cell: ({value}) =>
      /* if (value)
            {
            var valueSplit = value.split(':');
            var seconds = (+valueSplit[0]) * 60 * 60 + (+valueSplit[1]) * 60 + (+valueSplit[2]);
            return seconds
            }

            return 0; */
      value || '0',
    width: 200,
  },
  {
    Header: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.Notes,
    // Footer: APPDATA.FIELD_NAME.PROFILE_HISTORY.TABLE.Notes,
    accessor: APPDATA.FIELD_NAME.PROFILE_HISTORY.DETAIL_TABLE.Notes,
    width: 900,
  },
];

export const GROUPED_COLUMNS = [
  //   {
  //     Header: 'Id',
  //     Footer: 'Id',
  //     accessor: 'id'
  //   },
  //   {
  //     Header: 'Name',
  //     Footer: 'Name',
  //     columns: [
  //       {
  //         Header: 'First Name',
  //         Footer: 'First Name',
  //         accessor: 'first_name'
  //       },
  //       {
  //         Header: 'Last Name',
  //         Footer: 'Last Name',
  //         accessor: 'last_name'
  //       }
  //     ]
  //   },
  //   {
  //     Header: 'Info',
  //     Footer: 'Info',
  //     columns: [
  //       {
  //         Header: 'Date of Birth',
  //         Footer: 'Date of Birth',
  //         accessor: 'date_of_birth'
  //       },
  //       {
  //         Header: 'Country',
  //         Footer: 'Country',
  //         accessor: 'country'
  //       },
  //       {
  //         Header: 'Phone',
  //         Footer: 'Phone',
  //         accessor: 'phone'
  //       }
  //     ]
  //   }
];
